/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ paid: NonNullable<unknown> }} Members_Seats_In_UseInputs */



/**
* | output |
* | --- |
* | "of {paid} in use" |
*
* @param {Members_Seats_In_UseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_seats_in_use = /** @type {((inputs: Members_Seats_In_UseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Seats_In_UseInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`von ${i?.paid} belegt`)
	return /** @type {LocalizedString} */ (`of ${i?.paid} in use`)
});